import React,{useState,useEffect} from 'react'
import Image from 'next/image';
    
const InstallationBanner = ({page,bannertext,ban1x,ban2x,ban360,bantab,banalt,apostropheBefore, apostropheAfter, ashlokBefore, ashlokAfter}) => {
    const [pageData, setPageData] = useState({});
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fetch('/data/data.json');
          const data = await response.json();
          setPageData(data);
              //  console.log(data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, []);
    
    const makeSmallS = (text) => {
      return text.replace(/\((.*?)\)/g, (match, content) => {

        if (content.toLowerCase().includes("ashlok\'s")) {
          //console.log("matched at first if")
          //return `(<span className='vollkorn-sc-semibold'>${content}</span>)`;
          const highlightedContent = content.toLowerCase().replace(/ashlok's/gi, "<span class='vollkorn-sc-semibold'>$&</span>");
          return `(${highlightedContent})`;
        }
        // Check if the content contains an "s"
        else if (content.includes('s')) {
          // If it does, wrap it in a span with smaller font size
          return `(<span style="font-size: 70%">${content}</span>)`;
        } else {
          // Otherwise, return the content as is
          return `(${content})`;
        }
      });
    };

    const renderBannerText = () => {
      if (bannertext) {
        return <span>{bannertext}</span>;
      }
  
      if (ashlokBefore || ashlokAfter) {
        // Handle Ashlok content
        return (
          <span>
            {ashlokBefore && <span>{ashlokBefore}</span>}
            <span className='pl-2' style={{fontFamily: 'vollkorn-sc-regular' ,fontSize:'120%'}}>A</span><span style={{fontFamily: 'vollkorn-sc-regular'}} className=' pr-2 '>shlok{ashlokAfter ? "'s" : ''}</span>
            {ashlokAfter && <span>{ashlokAfter}</span>}
          </span>
        );
      }
  
      if (apostropheBefore || apostropheAfter) {
        // Handle apostrophe content
        return (
          <span>
            {apostropheBefore && <span>{apostropheBefore}</span>}
            <span style={{ fontSize: '70%' }}>s</span>
            {apostropheAfter && <span>{apostropheAfter}</span>}
          </span>
        );
      }
  
      // Default fallback if no text is provided
      return <span></span>;
    };


    // Accessing the 'home_page_title' for the selected language
    const ban1_alt = pageData[page]?.ban1_alt || '';
  
    return (
      <picture className='relative w-full  flex flex-col justify-center items-center    lg:h-auto sm:mt-14 md:mt-14 lg:mt-0 h-auto'>
      <source media="(max-width: 600px)" srcSet={ban360.src} />
  {/* Tablet (426px to 899px) */}
  <source media="(min-width: 601px) and (max-width: 900px)" srcSet={bantab.src} />
 <source media="(min-width: 901px)" srcSet={`${ban2x.src} 1x, ${ban2x.src} 2x`} />
       <img
         src={ban2x.src}
         alt={banalt}
         width={3840}
         height={900}
         className='block w-full  lg:h-auto object-cover object-center'
       />
     </picture>
      // <div className='relative w-full flex flex-col justify-center items-center  '>
       
       
      //           <Image  src={ban2x} alt={banalt} 
      //          srcSet={`${ban1x} 1x, ${ban2x} 2x ${ban3x ? `, ${ban3x} 360w` : ''}`}
      //          //layout="fill"         // Use 'fill' to make the image fill the container
      //         // Adjust how the image fits the container
      //           className='block w-full h-auto sm-small:h-[20vh] sm:h-[20vh] md-small:h-[30vh] md:h-[30vh] lg:h-auto object-cover'
                
               
      //           />
      //            <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-3xl  text-white uppercase font-semibold' style={{ fontFamily: 'cinzel, sans-serif' }}>
      //           {
      //             {renderBannerText()}
      //       </div>
           
      // </div>
    )
}

export default InstallationBanner
